import React, { memo } from 'react';
import { ArrowUpRightIcon, Clock3Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AboutPageHero } from '../components/AboutPageHero';
const stories = [{
  category: 'Field notes',
  title: 'Reading the seasons on the Manaslu Circuit',
  excerpt: 'What the changing light, trail conditions, and village rhythms reveal about choosing the right time to walk.',
  date: '08 October 2025',
  readTime: '6 min read',
  image: 'https://images.unsplash.com/photo-1483347756197-71ef80e95f73?auto=format&fit=crop&w=1100&q=85'
}, {
  category: 'Trek preparation',
  title: 'How to prepare well for Larkya La',
  excerpt: 'A practical, grounded guide to altitude, conditioning, layering, and the quiet confidence that good preparation brings.',
  date: '21 September 2025',
  readTime: '8 min read',
  image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1100&q=85'
}, {
  category: 'Culture & community',
  title: 'The warmth of a Nubri Valley welcome',
  excerpt: 'A slower look at the food, faith, and generosity that make the upper Manaslu valleys so memorable.',
  date: '02 September 2025',
  readTime: '5 min read',
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=1100&q=85'
}, {
  category: 'Responsible travel',
  title: 'Leaving a lighter footprint in the Himalaya',
  excerpt: 'The small decisions that protect fragile trails and ensure trekking continues to support mountain communities.',
  date: '19 August 2025',
  readTime: '7 min read',
  image: 'https://images.unsplash.com/photo-1494548162494-384bba4ab999?auto=format&fit=crop&w=1100&q=85'
}, {
  category: 'Guide journal',
  title: 'A day in the life of a Manaslu trek leader',
  excerpt: 'Before the first boots are laced, there is a day of observations, care, and finely tuned mountain judgement.',
  date: '04 August 2025',
  readTime: '5 min read',
  image: 'https://images.unsplash.com/photo-1500042600524-37ecb686c775?auto=format&fit=crop&w=1100&q=85'
}, {
  category: 'Routes',
  title: 'Beyond the pass: the descent to Bimthang',
  excerpt: 'Why one of the circuit’s most dramatic days is also an invitation to slow down and look closely.',
  date: '16 July 2025',
  readTime: '6 min read',
  image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1100&q=85'
}];
export function BlogsPage() {
  return <main className="w-full bg-[#f7f4ed] text-[#233a32]" data-id="element-465" data-mp="1fb7b82sygi5f">
      <AboutPageHero eyebrow="Journal" title="Stories from the mountain." description="Field notes, practical guidance, and considered perspectives from the people who know Manaslu best." imageUrl="https://images.unsplash.com/photo-1464278533981-50106e6176b1?auto=format&fit=crop&w=2000&q=85" data-id="element-466" data-mp="1fdtugzp7km3h" />
      <section className="mx-auto max-w-6xl px-6 py-16 sm:py-24" data-id="element-467" data-mp="3cazl1kgme70t">
        <div className="mb-12 flex flex-col justify-between gap-4 border-b border-[#d9d0bf] pb-6 sm:flex-row sm:items-end" data-id="element-468" data-mp="3c8lot8a7eoro">
          <div data-id="element-469" data-mp="3m0iz8cte1cpc">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9a7b3e]" data-id="element-470" data-mp="3lzzk13v4h2f0">
              The Manaslu edit
            </p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl" data-id="element-471" data-mp="3qykj2zyn1g1v">
              Notes worth carrying with you.
            </h2>
          </div>
          <p className="text-sm text-[#53645b]" data-id="element-472" data-mp="2ya57kneptfva">
            Guidance for the path ahead and stories from the trail.
          </p>
        </div>
        <div className="grid gap-x-7 gap-y-12 md:grid-cols-2 lg:grid-cols-3" data-id="element-473" data-mp="3386sldvpbp9e">
          {stories.map(story => <article key={story.title} className="flex flex-col" data-id="element-474" data-mp="386rt7eev8ayd">
              <img src={story.image} alt="" className="aspect-[4/3] w-full object-cover" data-id="element-475" data-mp="iir3cnc4s8lv" />
              <p className="mt-5 text-xs font-semibold uppercase tracking-[0.18em] text-[#9a7b3e]" data-id="element-476" data-mp="l3yxy7u8uu59">
                {story.category}
              </p>
              <h2 className="mt-3 font-serif text-2xl leading-tight" data-id="element-477" data-mp="h3onoizf5hkl">
                {story.title}
              </h2>
              <p className="mt-3 text-sm leading-7 text-[#53645b]" data-id="element-478" data-mp="v3fwm5b2w7rq">
                {story.excerpt}
              </p>
              <div className="mt-5 flex items-center justify-between border-t border-[#d9d0bf] pt-4 text-xs text-[#67766e]" data-id="element-479" data-mp="q5eg9s51emjy">
                <span data-id="element-480" data-mp="101rb4tcbj6ga">{story.date}</span>
                <span className="inline-flex items-center gap-1" data-id="element-481" data-mp="100pvebkcxvs8">
                  <Clock3Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-482" data-mp="1dsw2z99g2ug2" />
                  {story.readTime}
                </span>
              </div>
              <Link to="/contact" className="mt-5 inline-flex w-fit items-center gap-2 text-sm font-semibold text-[#233a32] hover:text-[#9a7b3e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4" data-id="element-483" data-mp="18vmdjtm22is8">
                Request the full story{' '}
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-484" data-mp="26fmcbg1xvpe2" />
              </Link>
            </article>)}
        </div>
      </section>
    </main>;
}